import FooterPrivacy from 'src/views/auth/components/baseTemplate/FooterPrivacy';
import TooltipIcon from 'src/components/ui/tooltip';
import { useLocalization } from 'src/utils/useLocalization';
import ViewInformation from '../information/components/View';
import { AccountType, Country } from 'src/utils/enums/payment.enum';
import './styles.scss';

const DetailsComponent = () => {
    const { payments } = useLocalization();
    const paymentData = {
        accountDetail: {
            accountNumber: '2123985751',
            country: Country.Canada,
            customerName: 'Fred Flintstone',
            vehicleMake: 'Volkswagen',
            vehicleModel: 'Atlas',
            vehicleYear: '2024',
            bodyStyle: 'SEL',
            maturityDate: '',
            accountType: AccountType.OperatingLease,
            accountStatus: 'Active',
            address: {
                AddressLine1: '1234 Teststreet',
                StateOrProvince: 'AB',
                City: 'Bedrock',
                TypeCode: '',
                PostalCode: '20191',
            },
            prePayLease: false,
            singlePayLease: false,
            repossessed: false,
            vin: 'WVZZZ12345678E123',
            processStatus: '',
            TermTypeStatus: '',
            balloonFinanceType: '',
            paymentSource: '',
            contractTerm: 0,
            partyId: 0,
        },
        privacyFlag: false,
        isBrassHatDealer: false,
        bankAccountDetails: {
            ccNumber: 0,
            accountNumber: '',
            routingNumber: '',
            accountType: 0,
        },
    };
    const editHandler = () => {
        return;
    };
    const returnHandler = () => {
        return;
    };
    return (
        <div className='dashboard-content-wrapper'>
            <div className='dashboard-content-container'>
                <div className='payments-details-wrapper'>
                    <section className='o-content-section  '>
                        <div className=''>
                            <h5 className='u-mb-large'>
                                <span className='c-section-heading__title-text'>
                                    {payments.PAYMENT_MAKE_TITLE}
                                </span>
                            </h5>
                            <section className='c-form-section'>
                                <div className='c-form-section__content'>
                                    <div className='title'>
                                        <h6>
                                            <span className='c-section-heading__title-text'>
                                                {
                                                    payments.PAYMENT_INFORMATION_TITLE
                                                }
                                            </span>
                                        </h6>
                                    </div>
                                    <div className='o-fieldset__row u-mt-large u-mb-large'>
                                        <div className='o-layout'>
                                            <div className='o-layout__item  u-1/3  u-1/1@s'>
                                                <div className='c-form-field'>
                                                    <div className='c-form-field__box'>
                                                        <div>
                                                            <label
                                                                htmlFor='m1l7e063'
                                                                className='c-form-field__label u-mr-xsmall'
                                                            >
                                                                {
                                                                    payments.PAYMENT_INFORMATION_AMOUNTLABEL
                                                                }
                                                            </label>
                                                        </div>
                                                        <span>$ 440</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='o-layout__item  u-1/3  u-1/1@s'>
                                                <div className='c-form-field'>
                                                    <label
                                                        htmlFor='m1l7e063'
                                                        className='c-form-field__label'
                                                    >
                                                        {
                                                            payments.PAYMENT_INFORMATION_REASONLABEL
                                                        }
                                                    </label>
                                                    <span>Regular Payment</span>
                                                </div>
                                            </div>
                                            <div className='o-layout__item  u-1/3  u-1/1@s'>
                                                <div className='c-form-field'>
                                                    <label
                                                        htmlFor='m1l7e063'
                                                        className='c-form-field__label'
                                                    >
                                                        {
                                                            payments.PAYMENT_INFORMATION_TYPELABEL
                                                        }
                                                    </label>
                                                    <span>
                                                        Chequing Account
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='o-fieldset__row u-mt-large'>
                                        <div className='o-layout'>
                                            <div className='o-layout__item  u-1/2  u-1/1@s'>
                                                <div className='c-form-field'>
                                                    <div className='c-form-field__box'>
                                                        <div>
                                                            <label
                                                                htmlFor='m1l7e063'
                                                                className='c-form-field__label u-mr-xsmall'
                                                            >
                                                                {
                                                                    payments.PAYMENT_INFORMATION_DEALERREFLABEL
                                                                }
                                                            </label>
                                                        </div>
                                                        <span>DE1234</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='o-layout__item  u-1/2  u-1/1@s'>
                                                <div className='c-form-field'>
                                                    <div className='c-form-field__box'>
                                                        <div>
                                                            <label
                                                                htmlFor='m1l7e063'
                                                                className='c-form-field__label u-mr-xsmall'
                                                            >
                                                                {
                                                                    payments.PAYMENT_INFORMATION_COMMENTLABEL
                                                                }
                                                            </label>
                                                            <TooltipIcon
                                                                text={
                                                                    payments.PAYMENT_INFORMATION_COMMENTIP
                                                                }
                                                            ></TooltipIcon>
                                                        </div>
                                                        <span>
                                                            Just a test comment
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='o-fieldset__row u-mt-large'>
                                        <div className='o-layout'>
                                            <div className='o-layout__item  u-1/2  u-1/1@s'>
                                                <div className='c-form-field'>
                                                    <div className='c-form-field__box'>
                                                        <div>
                                                            <label
                                                                htmlFor='m1l7e063'
                                                                className='c-form-field__label u-mr-xsmall'
                                                            >
                                                                {
                                                                    payments.PAYMENT_INFORMATION_TRANSACTION_ID
                                                                }
                                                            </label>
                                                        </div>
                                                        <span>DE1234</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='o-layout__item  u-1/2  u-1/1@s'>
                                                <div className='c-form-field'>
                                                    <div className='c-form-field__box'>
                                                        <div>
                                                            <label
                                                                htmlFor='m1l7e063'
                                                                className='c-form-field__label u-mr-xsmall'
                                                            >
                                                                {
                                                                    payments.PAYMENT_INFORMATION_WITHDRAWAL_DATE
                                                                }
                                                            </label>
                                                        </div>
                                                        <span>7/1/2024</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='o-fieldset__row u-mt-large'>
                                        <div className='o-layout'>
                                            <div className='o-layout__item  u-1/1  u-1/1@s'>
                                                <div className='o-fieldset__row button-group'>
                                                    <button
                                                        className={
                                                            'c-btn c-btn--secondary u-mr-small'
                                                        }
                                                        type='button'
                                                        onClick={returnHandler}
                                                    >
                                                        <span className='c-btn__text'>
                                                            {
                                                                payments.PAYMENT_INFORMATION_RETURN_LABEL
                                                            }
                                                        </span>
                                                    </button>
                                                    <button
                                                        className={'c-btn'}
                                                        type='button'
                                                        onClick={editHandler}
                                                    >
                                                        <span className='c-btn__text'>
                                                            {
                                                                payments.PAYMENT_INFORMATION_EDIT_LABEL
                                                            }
                                                        </span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <ViewInformation
                                data={paymentData}
                            ></ViewInformation>
                        </div>
                    </section>
                    <section className='privacy-footer-container '>
                        <FooterPrivacy />
                    </section>
                </div>
            </div>
        </div>
    );
};

export default DetailsComponent;
